import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    goal: null

}
export const getCompanyGoal = createAsyncThunk(
    "getCompanyGoal",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/company/fetch-company-goal?page=${body.page}&search=${body.search}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)
export const addCompanyGoal = createAsyncThunk(
    "addCompanyGoal",
    async (body, { rejectWithValue }) => {
        const formData = new FormData();
        formData.append("cg_title", body.cg_title);
        formData.append("cg_description", body.cg_description)
        formData.append("cg_icon", body.cg_icon)
        try {
            const response = await instance.post("/realestate/company/add-company-goal", formData);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

export const CompanyGoalSlice = createSlice({
    name: 'CompanyGoalSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getCompanyGoal.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getCompanyGoal.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;
        })
        builder.addCase(getCompanyGoal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });
        builder.addCase(addCompanyGoal.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(addCompanyGoal.fulfilled, (state, action) => {
            state.loading = false;
            state.goal = action.payload;
            state.count = action.payload?.count;
        })
        builder.addCase(addCompanyGoal.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });




    },

})

export default CompanyGoalSlice.reducer;